export class InventoryVolume {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerVolumeId",
            "baseName": "providerVolumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionKeyId",
            "baseName": "encryptionKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "isAwsManagedKey",
            "baseName": "isAwsManagedKey",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "availabilityZone",
            "baseName": "availabilityZone",
            "type": "string",
            "format": ""
        },
        {
            "name": "excludedFromBackupAt",
            "baseName": "excludedFromBackupAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "isRoot",
            "baseName": "isRoot",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "volumeSettings",
            "baseName": "volumeSettings",
            "type": "VolumeSettings",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InventoryVolume.attributeTypeMap;
    }
    constructor() {
    }
}
